export function useSocketIO() {
  const nuxtApp = useNuxtApp();
  return nuxtApp.$socket;
}
